<style lang="sass" scoped>

</style>
<template>
    <Card>
        <!-- 搜索 -->
        <div v-if="offModel">
            <!-- <div class="search-div">
                <Input placeholder="商品名" clearable v-model="searchObj.val" style="width: 200px; margin-right:8px;" />
                <Button type="primary" @click="searchItem">搜索</Button>
            </div> -->

            <div class="handle-div">
                <Button type="success" @click="addData(1)" :disabled="buttonList.addDisabled" style="margin-right:8px;">添加</Button>
                <Button type="primary" @click="addData(2)" :disabled="buttonList.editDisabled" style="margin-right:8px;">修改</Button>
                <Button type="error" @click="todelData" :disabled="buttonList.delDisabled">删除</Button>
            </div>
            <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-select-all="selectAll" @on-selection-change="selectChange" @on-sort-change="sortCustom"></Table>
            <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[5,10,15,20]" placement="top" class="pages"/>
            <!-- 删除弹框组件 -->
            <DeleteDialog ref="deleteChild" @ievent = "ievent"></DeleteDialog>
        </div>

        <EditModel :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData" ref="addModal"></EditModel>
    </Card>
</template>

<script>
import Side from '../common/side.vue'
import common from '@/common/common.js';
import time from '@/common/time.js';
import EditModel from './components/editModel';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import moment from 'moment';
    export default {
        name: "goodsAdmin",
        components: {
            EditModel,
            DeleteDialog
        },
        data(){
            return{
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                off: false,
                indexData: [],
                selectChangeData: [],
                changeDatas: [], //单个编辑的输入框
                statusModel:{//商品状态弹框
                    title:"改变商品状态",
                    showStatus:false,
                    disabled:false
                },
                statusFormData:{
                    status:"1",
                    id:0
                },
                tableList:{//表格组
                    dataTitle: { good_des: '商品描述',sale_price: "商品促销价格",sort_num:"权重",good_stock:"商品库存量"},  //伸缩框  显示字段
                    hasSelectData:{},//已选中的行的数据
                    tableData: [
                        {id: 1,nums:'45325943253',cont:'2312dfgdsj多少功夫可是大哥发快递',peoples:'李鑫',pepSec:'王曼妮',lever:'1',overs:'1',marks:'nf快快快点',fuStatus:'1'}
                    ]//表格数据
                },
                addBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObj:{
                    val:""
                },
                titleName: [
                    { //多选框
                        type: 'selection',
                        width: 60,
                        align: 'center',
                    },
                    {
                        title: '角色名称',
                        key: 'name',
                        minWidth: 100
                    },
                    {
                        title: '角色备注',
                        key: 'describe',
                        minWidth: 100
                    },
                    {
					    title: '状态',
					    key: 'status',
					    minWidth:80,
						render: (h, params) => {
						    let color = '#13C351'
						    let status = '正常'
						    switch (params.row.status){
						        case 1:
						        color = '#13C351'
						        status = '正常'
						        break
						        case 2:
						        color = '#aaa'
						        status = '禁用'
                                break
                                case 3:
						        color = '#aaa'
						        status = '禁用'
						        break
						        default:
						        color = '#f00'
						        status = '未知'

						    }
						    return h('span', {style:{color:color}},status);
						}
					},

                ],

            }
        },
        created (){
            this.getData()
        },
        watch: {

        },
        methods: {
            searchItem(){

            },
            todelData() {
                this.$refs.deleteChild.showit();
            },
            // 批量删除
            ievent() {
                let getData = {
                    id: this.tableList.hasSelectData.id,
                }
                this.axios.post(this.config.urlArray.rolesDestroy, getData).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.clearbtnStatus();
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    common.msg('error','删除失败')
                })
            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        size:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order
                    }
                }
                this.axios.get(this.config.urlArray.rolesShow,getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    if(resData){
                        this.tableList.tableData = resData  //渲染数据
                        this.page.total = result.data.data.paging.total
                        this.loading = false
                    }else{
                        return false
                    }
            }).catch((err) => {
                common.msg('error','获取失败',()=>{})
            });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },

            selectChange(res){ // 只要选中项发生变化时就会触发，返回值为 selection，已选项。
             this.selectChangeData = res
             if(res.length == 1){
                    this.buttonList.delDisabled = false
                    this.buttonList.editDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else if(res.length > 1){
                    this.buttonList.delDisabled = false
                    this.buttonList.editDisabled = true
                    this.tableList.hasSelectData = {}
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            addData (type) {  //添加或编辑数据
            this.offModel = false
              this.addBox.showModel = true
              this.type = type
                if(type == 2){
                    this.addBox.editFormData = this.tableList.hasSelectData
                }

                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                     this.offModel = true
                    this.getData();
                }
            },
            selectAll(res){  //点击全选时触发，返回值为 selection，已选项。  选择所有的选项
              this.buttonList.delDisabled = false
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus(){ //删除后清空编辑数据  与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>



